import React from 'react'
import AppStoreIcon from '../../../assets/images/icons8-app-store.svg';
import PlayStore from '../../../assets/images/icons8-play-store.svg';
import Github from '../../../assets/images/icons8-github.svg';
import WebIcon from '../../../assets/images/webicon.svg';
import './style.css';   
export default function FeaturesSection({features = [],project}) {
    

    return (
        <div className='features-container'>
            {project.features?
            <p className='feature-title'>Key Features</p>:null}
            {project.features?project.features.map((feature,index)=>{
                return (
                    <div key={index} className='feature-container'>
                    <div className='feature-bullet' />
                    <p className='feature-text'>{feature.title}</p>
                </div>
                )
            }
            ):null}
             {project.description?
            <p className='feature-title'>About</p>:null}
             {project.description?
            <p className='feature-text'>{project.description}</p>:null}
            {project.techs?<div className='techs-container'>
            {project.techs.map((tech,index)=>{
                return (
                    <div key={index} className='tech-container'>
                        <p className='tech-text'>{tech}</p>
                     </div>
                )
            }
            )}
            </div>:null}
            <div className='download-links-container'>
                {project.appStore?
                    <DownloadLink link={project.appStore} icon={AppStoreIcon} text={"App Store"} />:null}
                {project.playStore?
                    <DownloadLink link={project.playStore} icon={PlayStore} text={"Play Store"} />:null}
                {project.webSite?
                    <DownloadLink link={project.webSite}  icon={WebIcon} text={"Website"} />:null}
                {project.github?
                    <DownloadLink link={project.github} icon={Github} text={"Github"} />:null}
            </div>
        </div>
    )
}



function DownloadLink({icon,text,link}) {
    const handleClick = ()=>{
        window.open(link);
    }
    return (
        <div onClick={handleClick} className='DownloadLink-container'>
            <img alt='' src={icon} className='appstoreIcon' />
            <p className='DownloadLink-content'>{text}</p>
        </div>
    )
}